type CoalescingRunnerOptions = {
  run: (isStopped: () => boolean) => Promise<unknown>
  onStart: () => void
  onEnd: () => void
}

// Runs one job at a time. Requests made in the same tick share a run, and requests made during a run get one
// more run after it. onStart and onEnd bracket the whole busy stretch, and stop() ends it at once.
// A failed run is not caught, so it still surfaces as an unhandled rejection.
export const makeCoalescingRunner = ({ onEnd, onStart, run }: CoalescingRunnerOptions) => {
  let isBusy = false
  let isRerunQueued = false
  let isStopped = false

  const end = () => {
    if (!isBusy) return

    isBusy = false

    onEnd()
  }

  const runOnce = async () => {
    try {
      await Promise.resolve()

      isRerunQueued = false

      if (!isStopped) await run(() => isStopped)
    } finally {
      if (isRerunQueued) runOnce()
      else end()
    }
  }

  const request = () => {
    if (isStopped) return

    if (isBusy) {
      isRerunQueued = true

      return
    }

    isBusy = true

    onStart()

    return runOnce()
  }

  const stop = () => {
    isStopped = true

    end()
  }

  return { request, stop }
}
